import AnimatedIcon from '../../reels/AnimatedIcon';
import WildTextAnim from '../../reels/WildTextAnim';
import { Graphics } from 'pixi.js';
import { GameConfigs } from './GameConfigs';

const scale = 0.9;

export const ReelConfig = {
	width: 5,
	height: 3,
	iconWidth: 232,
	iconHeight: 229,
	iconRealWidth: 216,
	iconRealHeight: 216,
	iconGap: 7,
	baitTime: 1000,
	scatterCodes: [10],
	divider: 'reel_divider',
	border: 'reel_border',
	reelsMask: false,
	// additional_assets: [
	//   {
	//     img: "reel_asset_1",
	//     pos: {
	//       x: 10,
	//       y: -44,
	//     },
	//     animate: false,
	//     anchor: { x: 0.5, y: 0 },
	//   },
	//   {
	//     img: "reel_asset_2",
	//     pos: {
	//       x: 1144,
	//       y: -44,
	//     },
	//     animate: false,
	//     anchor: { x: 0.5, y: 0 },
	//   },
	//   {
	//     img: "reel_asset_3",
	//     pos: {
	//       x: 22,
	//       y: 673 - 55,
	//     },
	//     animate: false,
	//     anchor: { x: 0.5, y: 0 },
	//   },
	//   {
	//     img: "reel_asset_4",
	//     pos: {
	//       x: 1144,
	//       y: 673 - 44,
	//     },
	//     animate: false,
	//     anchor: { x: 0.5, y: 0 },
	//   },
	//   {
	//     img: "reel_asset_5",
	//     pos: {
	//       x: 1144 / 2,
	//       y: -42,
	//     },
	//     animate: false,
	//     anchor: { x: 0.5, y: 0 },
	//   },
	//   {
	//     img: "reel_asset_6",
	//     pos: {
	//       x: 1144 / 2,
	//       y: 673 - 33,
	//     },
	//     animate: false,
	//     anchor: { x: 0.5, y: 0 },
	//   },
	//   {
	//     img: "reel_asset_7",
	//     pos: {
	//       x: 5,
	//       y: 10,
	//     },
	//     animate: false,
	//     anchor: { x: 0.5, y: 0 },
	//   },
	//   {
	//     img: "reel_asset_8",
	//     pos: {
	//       x: 1140,
	//       y: 30,
	//     },
	//     animate: false,
	//     anchor: { x: 0.5, y: 0 },
	//   },
	//   {
	//     img: "reel_asset_10",
	//     pos: {
	//       x: 70,
	//       y: 673 - 40,
	//     },
	//     animate: false,
	//     anchor: { x: 0, y: 0 },
	//   },
	//   {
	//     img: "reel_asset_9",
	//     pos: {
	//       x: 1140 - 1140 / 3 + 50,
	//       y: 673 - 40,
	//     },
	//     animate: false,
	//     anchor: { x: 0, y: 0 },
	//   },
	//   {
	//     img: "reel_asset_9",
	//     pos: {
	//       x: 35,
	//       y: -50,
	//     },
	//     animate: false,
	//     anchor: { x: 0, y: 0 },
	//   },
	//   {
	//     img: "reel_asset_10",
	//     pos: {
	//       x: 1140 - 1140 / 3 + 50,
	//       y: -50,
	//     },
	//     animate: false,
	//     anchor: { x: 0, y: 0 },
	//   },
	// ],
	animations: {
		bg: {
			pattern: 'frm_000$.png',
			start: 0,
			end: 23,
			speed: 0.5,
			loop: true
		}
	},
	icons: [
		{
			id: 0,
			IconClass: AnimatedIcon,
			icon: 'TEN_00000.png',
			type: 'minor',
			//   iconBg: "minor_5_bg",
			iconBlurred: 'minor_5_blurred',
			animation: {
				fg: {
					pattern: 'TEN_000$.png',
					start: 0,
					end: 24,
					speed: 0.5,
					loop: false,
					scale: {
						x: scale,
						y: scale
					},
					offsetX: 5,
					offsetY: 10
				}
			},
			width: 216,
			height: 216,
			name: 'ten'
		},
		{
			id: 1,
			IconClass: AnimatedIcon,
			icon: 'J_00000.png',
			type: 'minor',
			//   iconBg: "minor_4_bg",
			iconBlurred: 'minor_4_blurred',
			animation: {
				fg: {
					pattern: 'J_000$.png',
					start: 0,
					end: 24,
					speed: 0.5,
					loop: false,
					scale: {
						x: scale,
						y: scale
					},
					offsetX: 5,
					offsetY: 10
				}
			},
			width: 216,
			height: 216,
			name: 'jack'
		},
		{
			id: 2,
			IconClass: AnimatedIcon,
			icon: 'Q_00000.png',
			type: 'minor',
			//   iconBg: "minor_3_bg",
			iconBlurred: 'minor_3_blurred',
			animation: {
				fg: {
					pattern: 'Q_000$.png',
					start: 0,
					end: 24,
					speed: 0.5,
					loop: false,
					scale: {
						x: scale,
						y: scale
					},
					offsetX: 5,
					offsetY: 10
				}
			},
			width: 216,
			height: 216,
			name: 'queen'
		},
		{
			id: 3,
			IconClass: AnimatedIcon,
			icon: 'K_00000.png',
			type: 'minor',
			//   iconBg: "minor_2_bg",
			iconBlurred: 'minor_2_blurred',
			animation: {
				fg: {
					pattern: 'K_000$.png',
					start: 0,
					end: 24,
					speed: 0.5,
					loop: false,
					scale: {
						x: scale,
						y: scale
					},
					offsetX: 5,
					offsetY: 10
				}
			},
			width: 216,
			height: 216,
			name: 'king'
		},
		{
			id: 4,
			IconClass: AnimatedIcon,
			icon: 'A_00000.png',
			type: 'minor',
			//   iconBg: "minor_1_bg",
			iconBlurred: 'minor_1_blurred',
			animation: {
				fg: {
					pattern: 'A_000$.png',
					start: 0,
					end: 24,
					speed: 0.5,
					loop: false,
					scale: {
						x: scale,
						y: scale
					},
					offsetX: 5,
					offsetY: 10
				}
			},
			width: 216,
			height: 216,
			name: 'ace'
		},
		{
			id: 5,
			IconClass: AnimatedIcon,
			icon: 'cigar_00000.png',
			type: 'major',
			// iconBg: "major_5_bg",
			iconBlurred: 'major_5_blurred',
			iconBorder: 'major_5_frame',
			animation: {
				fg: {
					pattern: 'cigar_000$.png',
					start: 0,
					end: 23,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.96,
						y: 0.96
					}
				}
			},
			width: 216,
			height: 216,
			name: 'samurai'
		},
		{
			id: 6,
			IconClass: AnimatedIcon,
			icon: 'Cocktail_00000.png',
			// iconBg: "major_4_bg",
			type: 'major',
			iconBlurred: 'major_4_blurred',
			iconBorder: 'major_4_frame',
			animation: {
				fg: {
					pattern: 'Cocktail_000$.png',
					start: 0,
					end: 47,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.96,
						y: 0.96
					}
				}
			},
			width: 216,
			height: 216,
			name: 'helmet'
		},
		{
			id: 7,
			IconClass: AnimatedIcon,
			icon: 'Kalisha_00000.png',
			// iconBg: "major_3_bg",
			iconBlurred: 'major_3_blurred',
			type: 'major',
			iconBorder: 'major_3_frame',
			animation: {
				fg: {
					pattern: 'Kalisha_000$.png',
					start: 0,
					end: 47,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.96,
						y: 0.96
					}
				}
			},
			width: 216,
			height: 216,
			name: 'asteroid'
		},
		{
			id: 8,
			IconClass: AnimatedIcon,
			icon: 'Hera_00000.png',
			// iconBg: "major_2_bg",
			iconBlurred: 'major_2_blurred',
			type: 'major',
			iconBorder: 'major_2_frame',
			animation: {
				fg: {
					pattern: 'Hera_000$.png',
					start: 0,
					end: 47,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.96,
						y: 0.96
					}
				}
			},
			width: 216,
			height: 216,
			name: 'minister'
		},
		{
			id: 9,
			IconClass: AnimatedIcon,
			icon: 'tommy_00000.png',
			// iconBg: "major_1_bg",
			type: 'major',
			iconBlurred: 'major_1_blurred',
			iconBorder: 'major_1_frame',
			animation: {
				fg: {
					pattern: 'tommy_000$.png',
					start: 0,
					end: 47,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.96,
						y: 0.96
					}
				}
			},
			width: 216,
			height: 216,
			name: 'general'
		},
		{
			id: 10,
			IconClass: AnimatedIcon,
			Fg2Class: WildTextAnim,
			icon: 'scatter_00000.png',
			type: 'scatter',
			//   iconBg: "scatter_bg",
			iconBlurred: 'scatter_blurred',
			isScatter: true,
			animation: {
				fg: {
					pattern: 'scatter_000$.png',
					start: 0,
					end: 47,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.95,
						y: 0.95
					},
					offsetX: 10,
					offsetY: 0
				},
				fg2Index: 0,
				fg2Data: [
					{
						pattern: 'Scatter_000$.png',
						start: 0,
						end: 24,
						speed: 0.5,
						loop: true,
						offsetX: 10,
						offsetY: 145,
						scale: {
							x: 0.55,
							y: 0.55
						}
					}
				]
			},
			width: 216,
			height: 216,
			name: 'scatter'
		},
		{
			id: 11,
			IconClass: AnimatedIcon,
			Fg2Class: WildTextAnim,
			icon: 'money00.png',
			type: 'wild',
			// iconBg: "wild_bg",
			// iconBgRotate: "wild_bg",
			iconBgBonus: 'stickybg_00000.png',
			// iconBorder: "major_2_frame",
			iconBlurred: 'wild_blurred',
			isWild: true,
			isSticked: false,
			animation: {
				// frame: {
				//   pattern: "PORTAL$.png",
				//   start: 0,
				//   end: 47,
				//   speed: 0.5,
				//   loop: true,
				//   offsetX: -20,
				//   offsetY: -13,
				//   scale: {
				//     x: 1,
				//     y: 1,
				//   },
				// },
				bonusBg: {
					pattern: 'stickybg_000$.png',
					start: 0,
					end: 24,
					speed: 0.5,
					loop: true,
					offsetX: 0,
					offsetY: 0,
					scale: {
						x: 1,
						y: 1
					}
				},
				fg: {
					pattern: 'money$.png',
					start: 0,
					end: 95,
					speed: 0.5,
					loop: false,
					offsetX: 7,
					offsetY: 5,
					scale: {
						x: 1,
						y: 1
					},
					sound: 'wild_shooting_sfx'
				},
				fg2Index: 0,
				fg2Data: [
					{
						pattern: 'wx1_000$.png',
						start: 0,
						end: 22,
						speed: 0.5,
						loop: true,
						offsetX: -8,
						offsetY: 130
					},
					{
						pattern: 'wx2_000$.png',
						start: 0,
						end: 22,
						speed: 0.5,
						loop: true,
						offsetX: -5,
						offsetY: 130
					},
					{
						pattern: 'wx3_000$.png',
						start: 0,
						end: 22,
						speed: 0.5,
						loop: true,
						offsetX: -5,
						offsetY: 130
					},
					{
						pattern: 'wx4_000$.png',
						start: 0,
						end: 22,
						speed: 0.5,
						loop: true,
						offsetX: -5,
						offsetY: 130
					},
					{
						pattern: 'wx5_000$.png',
						start: 0,
						end: 22,
						speed: 0.5,
						loop: true,
						offsetX: -5,
						offsetY: 130
					}
				]
			},
			width: 216,
			height: 216,
			name: 'wild'
		},
		{
			id: 12,
			IconClass: AnimatedIcon,
			icon: '02_CrystalUnstable00.png',
			// iconBg: "major_2_bg",
			iconBlurred: 'special_blurred',
			animation: {
				fg: {
					pattern: '02_CrystalUnstable$.png',
					start: 0,
					end: 71,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.96,
						y: 0.96
					}
				}
				// frame: {
				//   pattern: "wildframegold_000$.png",
				//   start: 0,
				//   end: 34,
				//   speed: 0.5,
				//   loop: true,
				//   scale: {
				//     x: 0.96,
				//     y: 0.96,
				//   },
				// },
			},
			width: 216,
			height: 216,
			name: 'special'
		}
	],
	linesConfig: {
		lines: [
			[1, 1, 1, 1, 1],
			[0, 0, 0, 0, 0],
			[2, 2, 2, 2, 2],
			[0, 1, 2, 1, 0],
			[2, 1, 0, 1, 2],
			[0, 0, 1, 0, 0],
			[2, 2, 1, 2, 2],
			[1, 2, 2, 2, 1],
			[1, 0, 0, 0, 1]
		],
		animationTime: GameConfigs.settings.game_animation ? 2300 : 1000
	},
	reelMask: (u, d, w, h) => {
		var maskGraphics = new Graphics();
		maskGraphics.beginFill(0xffffff);
		maskGraphics.drawRoundedRect(-u, 0, w + d, h, 0);
		maskGraphics.endFill();
		return maskGraphics;
	},
	reelsMask2: (u, d, w, h) => {
		var maskGraphics = new Graphics();
		maskGraphics.beginFill(0xff0000);
		maskGraphics.drawRoundedRect(-u, 0, w + d, h, 0);
		maskGraphics.endFill();
		// var mask = Sprite.from(Texture.from("reel_mask"));
		// mask.y = -50;
		return maskGraphics;
	}
};
